<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Livello:</label>
                        <b-form-select v-model="filtroSettingLivelli.descrizioneLivello" type="search" id="tipoScale" placeholder="Inserire tipo scala" :options="tipoSettingLivelliOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Valore - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data dal:</label>
                        <date-picker v-model="filtroSettingLivelli.dataDal" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data al:</label>
                        <date-picker v-model="filtroSettingLivelli.dataAl" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-paziente-accettazione-setting-livelli-list-component ref="cmpRasPazienteScaleValutazioneListComponent" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-paziente-accettazione-setting-livelli-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazienteAccettazioneSettingLivelliListComponent from "../components/RsaPazienteAccettazioneSettingLivelliListComponent.vue";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteAccettazioneSettingLivelliListComponent,
        DatePicker,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            filtroSettingLivelli: { descrizioneLivello: null, dataDal: null, dataAl: null },
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            pathResourceTipoScala: "/accettazionersasettinglivelli/livelli",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            listKey: 0,
            filtroidAccettazione: { idAccettazione: null },
            tipoSettingLivelliOptions: [],
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroSettingLivelli"]) {
            me.filtroSettingLivelli = JSON.parse(sessionStorage["filtroSettingLivelli"]);
        }

        me.loadAccettazione();
        me.loadTipoSettingLivelli();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRasPazienteScaleValutazioneListComponent.init(me.jsonData);
                    me.showModalLoading = false;
                })
                .catch((error) => {
                    me.showModalLoading = false;
                    console.log(error);
                });
        },

        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroSettingLivelli"] = JSON.stringify(me.filtroSettingLivelli);
            me.$refs.cmpRasPazienteScaleValutazioneListComponent.init(me.jsonData);
        },
        onReset() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.filtroSettingLivelli = { descrizioneLivello: null, dataDal: null, dataAl: null };
            sessionStorage["filtroSettingLivelli"] = JSON.stringify(me.filtroSettingLivelli);
            me.$refs.cmpRasPazienteScaleValutazioneListComponent.init(me.jsonData);
        },

        loadTipoSettingLivelli() {
            let me = this;
            me.filtroidAccettazione = { idAccettazione: me.idAccettazione };
            me.loadDataResources(me.pathResourceTipoScala, me.filtroidAccettazione, me.loadTipoSettingLivelliSuccess, me.loadTipoSettingLivelliError);
        },
        loadTipoSettingLivelliSuccess(response) {
            let me = this;
            me.tipoSettingLivelliOptions = [];
            if (response.data.data.length > 0) {
                me.tipoSettingLivelliOptions = response.data.data.map((item) => {
                    return { value: item.tipologia, text: item.tipologia };
                });
            }
        },
        loadTipoSettingLivelliError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle scale", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
    },
};
</script>

<style></style>
